/**
 * Shared by the Vite Leo proxy and the browser client. Keep this file free of
 * `@/` imports so `vite.config.ts` can load it in Node.
 */

export const LEO_OPENROUTER_CHAT_PATH = "/api/leo/chat"

/** Cheap paid ids. Tried first when free providers fail. */
export const LEO_CHEAP_MODELS = [
  "openai/gpt-4o-mini",
  "google/gemini-2.0-flash-001",
] as const

export const LEO_FREE_MODEL_FALLBACKS = [
  "google/gemma-4-26b-a4b-it:free",
  "inclusionai/ling-3.0-flash-sante:free",
  "qwen/qwen3.8-27b:free",
] as const

export type LeoChatRole = "system" | "user" | "assistant"

export type LeoChatMessage = {
  role: LeoChatRole
  content: string
}

export function assertLeoAllowedModel(model: string): string {
  const id = model.trim()
  if (!id || /\s/.test(id)) {
    throw new Error("Leo needs a valid OpenRouter model id")
  }
  if (
    id.endsWith(":free") ||
    LEO_CHEAP_MODELS.includes(id as (typeof LEO_CHEAP_MODELS)[number])
  ) {
    return id
  }
  throw new Error(
    "Leo allows OpenRouter :free models or the cheap paid ids gpt-4o-mini and gemini-2.0-flash-001",
  )
}

/** @deprecated Use assertLeoAllowedModel. */
export function assertLeoFreeModel(model: string): string {
  return assertLeoAllowedModel(model)
}

export function resolveLeoChatModels(preferred?: string): string[] {
  const models: string[] = []
  const add = (id: string) => {
    if (!models.includes(id)) models.push(id)
  }
  if (preferred?.trim()) add(assertLeoAllowedModel(preferred))
  for (const id of LEO_CHEAP_MODELS) add(id)
  for (const id of LEO_FREE_MODEL_FALLBACKS) add(id)
  return models
}

/** @deprecated Use resolveLeoChatModels. */
export function resolveLeoFreeModels(preferred?: string): string[] {
  return resolveLeoChatModels(preferred)
}
